import React from 'react';
import PropTypes from 'prop-types';

import {Text} from '@albert-io/atomic';

import './toolbar-progress-indicator.scss';

const ToolbarProgressIndicator = ({answeredQuestionCount, totalQuestionCount}) => {
  return (
    <Text bold size='s' className='toolbar-progress-indicator u-pad-lr_1 u-mar-r_1'>
      Progress:{' '}
      <span className='toolbar-progress-indicator__unanswered-count'>{answeredQuestionCount}</span>
      <span className='toolbar-progress-indicator__divider'>/</span>
      {totalQuestionCount}
    </Text>
  );
};

ToolbarProgressIndicator.propTypes = {
  answeredQuestionCount: PropTypes.number.isRequired,
  totalQuestionCount: PropTypes.number.isRequired
};

export default ToolbarProgressIndicator;
